var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-editor',{ref:"contentBlog",attrs:{"useCustomImageHandler":""},on:{"image-added":_vm.handleImageAdded,"image-removed":_vm.handleImageRemove,"text-change":_vm.TextChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }